//Commented not supported languages
export enum Language {
  "af-ZA" = "af-ZA", // Afrikaans (South Africa)
//  "am-ET" = "am-ET", // Amharic (Ethiopia)
//  "ar-AE" = "ar-AE", // Arabic (United Arab Emirates)
//  "ar-BH" = "ar-BH", // Arabic (Bahrain)
//  "ar-DZ" = "ar-DZ", // Arabic (Algeria)
//  "ar-EG" = "ar-EG", // Arabic (Egypt)
//  "ar-IQ" = "ar-IQ", // Arabic (Iraq)
//  "ar-JO" = "ar-JO", // Arabic (Jordan)
//  "ar-KW" = "ar-KW", // Arabic (Kuwait)
//  "ar-LB" = "ar-LB", // Arabic (Lebanon)
//  "ar-LY" = "ar-LY", // Arabic (Libya)
//  "ar-MA" = "ar-MA", // Arabic (Morocco)
//  "ar-OM" = "ar-OM", // Arabic (Oman)
//  "ar-QA" = "ar-QA", // Arabic (Qatar)
  "ar-SA" = "ar-SA", // Arabic (Saudi Arabia)
//  "ar-SY" = "ar-SY", // Arabic (Syria)
//  "ar-TN" = "ar-TN", // Arabic (Tunisia)
//  "ar-YE" = "ar-YE", // Arabic (Yemen)
//  "as-IN" = "as-IN", // Assamese (India)
//  "az-AZ" = "az-AZ", // Azerbaijani (Latin, Azerbaijan)
//  "bg-BG" = "bg-BG", // Bulgarian (Bulgaria)
//  "bn-BD" = "bn-BD", // Bangla (Bangladesh)
//  "bn-IN" = "bn-IN", // Bengali (India)
//  "bs-BA" = "bs-BA", // Bosnian (Bosnia and Herzegovina)
  "ca-ES" = "ca-ES", // Catalan
  "cs-CZ" = "cs-CZ", // Czech (Czechia)
//  "cy-GB" = "cy-GB", // Welsh (United Kingdom)
  "da-DK" = "da-DK", // Danish (Denmark)
//  "de-AT" = "de-AT", // German (Austria)
  "de-CH" = "de-CH", // German (Switzerland)
  "de-DE" = "de-DE", // German (Germany)
  "el-GR" = "el-GR", // Greek (Greece)
  "en-AU" = "en-AU", // English (Australia)
//  "en-CA" = "en-CA", // English (Canada)
  "en-GB" = "en-GB", // English (United Kingdom)
//  "en-HK" = "en-HK", // English (Hong Kong SAR)
  "en-IE" = "en-IE", // English (Ireland)
  "en-IN" = "en-IN", // English (India)
//  "en-KE" = "en-KE", // English (Kenya)
//  "en-NG" = "en-NG", // English (Nigeria)
  "en-NZ" = "en-NZ", // English (New Zealand)
//  "en-PH" = "en-PH", // English (Philippines)
//  "en-SG" = "en-SG", // English (Singapore)
//  "en-TZ" = "en-TZ", // English (Tanzania)
  "en-US" = "en-US", // English (United States)
  "en-ZA" = "en-ZA", // English (South Africa)
//  "es-AR" = "es-AR", // Spanish (Argentina)
//  "es-BO" = "es-BO", // Spanish (Bolivia)
//  "es-CL" = "es-CL", // Spanish (Chile)
//  "es-CO" = "es-CO", // Spanish (Colombia)
//  "es-CR" = "es-CR", // Spanish (Costa Rica)
//  "es-CU" = "es-CU", // Spanish (Cuba)
//  "es-DO" = "es-DO", // Spanish (Dominican Republic)
//  "es-EC" = "es-EC", // Spanish (Ecuador)
  "es-ES" = "es-ES", // Spanish (Spain)
//  "es-GQ" = "es-GQ", // Spanish (Equatorial Guinea)
//  "es-GT" = "es-GT", // Spanish (Guatemala)
//  "es-HN" = "es-HN", // Spanish (Honduras)
//  "es-MX" = "es-MX", // Spanish (Mexico)
//  "es-NI" = "es-NI", // Spanish (Nicaragua)
//  "es-PA" = "es-PA", // Spanish (Panama)
//  "es-PE" = "es-PE", // Spanish (Peru)
//  "es-PR" = "es-PR", // Spanish (Puerto Rico)
//  "es-PY" = "es-PY", // Spanish (Paraguay)
//  "es-SV" = "es-SV", // Spanish (El Salvador)
  "es-US" = "es-US", // Spanish (United States)
//  "es-UY" = "es-UY", // Spanish (Uruguay)
//  "es-VE" = "es-VE", // Spanish (Venezuela)
//  "et-EE" = "et-EE", // Estonian (Estonia)
  "eu-ES" = "eu-ES", // Basque
  "fa-IR" = "fa-IR", // Persian (Iran)
  "fi-FI" = "fi-FI", // Finnish (Finland)
//  "fi-_P"H = "fil-PH", // Filipino (Philippines)
//  "fr-BE" = "fr-BE", // French (Belgium)
  "fr-CA" = "fr-CA", // French (Canada)
//  "fr-CH" = "fr-CH", // French (Switzerland)
  "fr-FR" = "fr-FR", // French (France)
//  "ga-IE" = "ga-IE", // Irish (Ireland)
  "gl-ES" = "gl-ES", // Galician
//  "gu-IN" = "gu-IN", // Gujarati (India)
  "he-IL" = "he-IL", // Hebrew (Israel)
  "hi-IN" = "hi-IN", // Hindi (India)
  "hr-HR" = "hr-HR", // Croatian (Croatia)
//  "hu-HU" = "hu-HU", // Hungarian (Hungary)
//  "hy-AM" = "hy-AM", // Armenian (Armenia)
  "id-ID" = "id-ID", // Indonesian (Indonesia)
//  "is-IS" = "is-IS", // Icelandic (Iceland)
  "it-IT" = "it-IT", // Italian (Italy)
//  "iu-LA"TN_CA = "iu-LATN-CA", // Inuktitut (Latin, Canada)
  "ja-JP" = "ja-JP", // Japanese (Japan)
//  "jv-ID" = "jv-ID", // Javanese (Latin, Indonesia)
//  "ka-GE" = "ka-GE", // Georgian (Georgia)
//  "kk-KZ" = "kk-KZ", // Kazakh (Kazakhstan)
//  "km-KH" = "km-KH", // Khmer (Cambodia)
//  "kn-IN" = "kn-IN", // Kannada (India)
  "ko-KR" = "ko-KR", // Korean (Korea)
//  "lo-LA" = "lo-LA", // Lao (Laos)
//  "lt-LT" = "lt-LT", // Lithuanian (Lithuania)
  "lv-LV" = "lv-LV", // Latvian (Latvia)
//  "mk-MK" = "mk-MK", // Macedonian (North Macedonia)
//  "ml-IN" = "ml-IN", // Malayalam (India)
//  "mn-MN" = "mn-MN", // Mongolian (Mongolia)
//  "mr-IN" = "mr-IN", // Marathi (India)
  "ms-MY" = "ms-MY", // Malay (Malaysia)
//  "mt-MT" = "mt-MT", // Maltese (Malta)
//  "my-MM" = "my-MM", // Burmese (Myanmar)
  "nb-NO" = "nb-NO", // Norwegian Bokmål (Norway)
//  "ne-NP" = "ne-NP", // Nepali (Nepal)
//  "nl-BE" = "nl-BE", // Dutch (Belgium)
  "nl-NL" = "nl-NL", // Dutch (Netherlands)
//  "or-IN" = "or-IN", // Oriya (India)
//  "pa-IN" = "pa-IN", // Punjabi (India)
  "pl-PL" = "pl-PL", // Polish (Poland)
//  "ps-AF" = "ps-AF", // Pashto (Afghanistan)
  "pt-BR" = "pt-BR", // Portuguese (Brazil)
  "pt-PT" = "pt-PT", // Portuguese (Portugal)
  "ro-RO" = "ro-RO", // Romanian (Romania)
  "ru-RU" = "ru-RU", // Russian (Russia)
//  "si-LK" = "si-LK", // Sinhala (Sri Lanka)
  "sk-SK" = "sk-SK", // Slovak (Slovakia)
//  "sl-SI" = "sl-SI", // Slovenian (Slovenia)
  "so-SO" = "so-SO", // Somali (Somalia)
//  "sq-AL" = "sq-AL", // Albanian (Albania)
//  "sr-LATN_RS" = "sr-LATN-RS", // Serbian (Latin, Serbia)
  "sr-RS" = "sr-RS", // Serbian (Cyrillic, Serbia)
//  "su-ID" = "su-ID", // Sundanese (Indonesia)
  "sv-SE" = "sv-SE", // Swedish (Sweden)
//  "sw-KE" = "sw-KE", // Kiswahili (Kenya)
//  "sw-TZ" = "sw-TZ", // Kiswahili (Tanzania)
//  "ta-IN" = "ta-IN", // Tamil (India)
//  "ta-LK" = "ta-LK", // Tamil (Sri Lanka)
//  "ta-MY" = "ta-MY", // Tamil (Malaysia)
//  "ta-SG" = "ta-SG", // Tamil (Singapore)
//  "te-IN" = "te-IN", // Telugu (India)
  "th-TH" = "th-TH", // Thai (Thailand)
//  "tr-TR" = "tr-TR", // Turkish (Türkiye)
  "uk-UA" = "uk-UA", // Ukrainian (Ukraine)
//  "ur-IN" = "ur-IN", // Urdu (India)
//  "ur-PK" = "ur-PK", // Urdu (Pakistan)
//  "uz-UZ" = "uz-UZ", // Uzbek (Latin, Uzbekistan)
  "vi-VN" = "vi-VN", // Vietnamese (Vietnam)
//  "wuu-CN = "wuu-CN", // Chinese (Wu, Simplified)
//  "yue-CN = "yue-CN", // Chinese (Cantonese, Simplified)
  "zh-CN" = "zh-CN", // Chinese (Mandarin, Simplified)
//  "zh-CN_GUANGXI" = "zh-CN-GUANGXI", // Chinese (Guangxi Accent Mandarin, Simplified)
//  "zh-CN_henan" = "zh-CN-henan", // Chinese (Zhongyuan Mandarin Henan, Simplified)
//  "zh-CN_liaoning" = "zh-CN-liaoning", // Chinese (Northeastern Mandarin, Simplified)
//  "zh-CN_shaanxi" = "zh-CN-shaanxi", // Chinese (Zhongyuan Mandarin Shaanxi, Simplified)
//  "zh-CN_shandong" = "zh-CN-shandong", // Chinese (Jilu Mandarin, Simplified)
//  "zh-CN_sichuan" = "zh-CN-sichuan", // Chinese (Southwestern Mandarin, Simplified)
  "zh-HK" = "zh-HK", // Chinese (Cantonese, Traditional)
  "zh-TW" = "zh-TW", // Chinese (Taiwanese Mandarin, Traditional)
  "zu-ZA" = "zu-ZA", // isiZulu (South Africa)
}